import { cx } from '@twind/core';

export default function DownloadIcon({ className }: { className?: string }) {
  return (
    <svg
      data-testid="download-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cx('ostro-download-icon', '~(w-6)', className)}
    >
      <path
        d="M5 15.5833V17.9167H19V15.5833"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 16L16 12.32L15.2 11.572L12.5652 13.996L12.5652 5L11.4348 5L11.4348 13.996L8.80001 11.572L8 12.32L12 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
